import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useToken from '../../hooks/useToken';
import Avatar from './Avatar';

const ImagenPerfil = ({ idUsuario }) => {

    const { token, setToken } = useToken();
    const [imagenPerfil, setImagenPerfil] = useState();
    const ObtenerImagenPerfil = async () => {
        console.log(`[ImagenPerfil] Fetching from API for user: ${idUsuario}`);
        const response = await fetch("/api/perfil/obtenerImagenPerfil/?idUsuario=" + idUsuario,
            {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'text/plain'
                }
            }).catch((error) => {
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            console.log(`[ImagenPerfil] ==== API success for user: ${idUsuario} ====`);
            // console.log(response);
            const data = await response.text();
            // console.log(data);
            console.log(`[ImagenPerfil] Response text received for user: ${idUsuario}. Length: ${data.length}`);
            setImagenPerfil(data)
            // Guardar la imagen en LocalStorage
            localStorage.setItem(`perfil_${idUsuario}`, data);
        }
        else {
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }


    }

    const CargarImagen = async () => {
        console.log(`[ImagenPerfil] CargarImagen started for user: ${idUsuario}`);
        var img_perfil = localStorage.getItem(`perfil_${idUsuario}`); 

        //Revisa si existe la variable de sesion. Si no existe, Obtiene los datos para guardarlos.
        if (img_perfil) {
            console.log(`[ImagenPerfil] Found in localStorage for user: ${idUsuario}`);
            setImagenPerfil(img_perfil);
        } else {
            console.log(`[ImagenPerfil] NOT found in localStorage for user: ${idUsuario}. Calling API.`);
            ObtenerImagenPerfil()
        }
    }

    useEffect(() => {
        CargarImagen()
    }, [idUsuario])

    return (
        <Link className="d-flex" to={"/perfil/" + idUsuario} >
            <Avatar src={imagenPerfil} size="xl" />

        </Link>
    );
};

ImagenPerfil.propTypes = {
    idUsuario: PropTypes.number
};

export default ImagenPerfil;
